import React from 'react'
import moment from 'moment'
import { COLORES } from '../../../config/colores'
import OperacionesDemoraEnVolcadoras from '../components/estadisticasVolcadoras/OperacionesDemoraEnVolcadoras'
// import ReferenciaMotivoDemora from '../components/estadisticasVolcadoras/ReferenciaMotivoDemora'

export const COLUMNS_DEMORA_EN_VOLCADORAS = [
  {
    name: 'inicioDeDemora',
    label: 'Inicio de demora',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: fecha => {
        const f = moment(fecha).format('DD-MM-YYYY HH:mm')
        return <>{f}</>
      },
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'finDeDemora',
    label: 'Fin de demora',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: fecha => {
        const f = moment(fecha).format('DD-MM-YYYY HH:mm')
        return <>{f}</>
      }
    }
  },
  {
    name: 'duracion',
    label: 'Duración',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'volcadoraCamiones',
    label: 'Volcadora',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      filterList: []
    }
  },
  {
    name: 'motivoDeDemora',
    label: 'Motivo de demora',
    options: {
      filter: true,
      sort: true
      // customBodyRender: (demora) => {
      //   return <ReferenciaMotivoDemora demora={demora} />
      // }
    }
  },
  {
    name: 'observacionesSupervisor',
    label: 'Observación',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'usuarioSupervisor',
    label: 'Supervisor',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'data',
    label: ' ',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (d) => {
        return <OperacionesDemoraEnVolcadoras data={d} />
      }
    }
  }
]

export const COLUMNS_ESTADISTICAS_VOLCADORAS = [
  {
    name: 'fecha',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: fecha => {
        const f = moment(fecha).format('DD-MM-YYYY')
        return <>{f}</>
      },
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'volcadoraCamiones',
    label: 'Volcadora',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'inicioEfectivo',
    label: 'Primer volcado',
    options: {
      filter: false,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: fecha => {
        const f = moment(fecha).format('HH:mm:ss')
        return <>{f}</>
      }
    }
  },
  {
    name: 'finEfectivo',
    label: 'Último volcado',
    options: {
      filter: false,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: fecha => {
        const f = moment(fecha).format('HH:mm:ss')
        return <>{f}</>
      }
    }
  },
  {
    name: 'horasDemoras',
    label: 'Demoras',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'cantidadCamiones',
    label: 'Cantidad de camiones',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'productividadHorasTurno',
    label: 'Productividad horas turno',
    options: {
      filter: false,
      sort: true
    }
  }
]
